var React = require('react');

function Warranty (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7 6H22.7575V17.8231C22.7575 21.7732 19.5514 24.9793 15.6014 24.9793H14.1561C10.2061 24.9793 7 21.7732 7 17.8231V6Z","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M10.7302 15.6553L13.4564 17.8231L19.0216 12.4221","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Warranty.defaultProps = {"viewBox":"0 0 30 30","fill":"none"};

module.exports = Warranty;

Warranty.default = Warranty;
